'use strict';

var AlgoliaSearchCore = require('../../AlgoliaSearchCore.js');
var createAlgoliasearch = require('../createAlgoliasearch.js');

module.exports = createAlgoliasearch(AlgoliaSearchCore, 'Browser (lite)');



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/browser/builds/algoliasearchLite.js
// module id = 567
// module chunks = 142807904292071